import { render, staticRenderFns } from "./RcTrainerActivity.vue?vue&type=template&id=664e69e7&"
import script from "./RcTrainerActivity.vue?vue&type=script&lang=js&"
export * from "./RcTrainerActivity.vue?vue&type=script&lang=js&"
import style0 from "./RcTrainerActivity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports